module.exports = __webpack_public_path__ + "static/media/ProximaNova-ExtrabldIt.200afa63.ttf";